import { isUSA } from "../constants/env";

/**
 * Returns the language that should be used for the app.
 * If isUSA is true, always returns "en" (English).
 * Otherwise returns the provided language.
 */
export const getAppLanguage = (language?: string): string => {
  if (isUSA) {
    return "en";
  }
  return language || "en";
};
